import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { BrowserProvider } from "ethers";
import HomePage from "./pages/HomePage"; // Profile Page
import NFTPage from "./pages/NFTPage"; // ВАМПТЕХ for NFT Uploads
import GalleryPage from "./pages/GalleryPage"; // МИР Feed Page
import VaultPage from "./pages/VaultPage"; // Personal Gallery Page
import SoundsPage from "./pages/SoundsPage"; // ВАМП SOUNDS Page
import RecordsPage from "./pages/RecordsPage"; // ВАМП RECORDS Page
import CryptPage from "./pages/CryptPage"; // ВАМП CRYPT Page
import SignupPage from "./pages/SignupPage"; // Signup Page
import UpdateCastlePage from "./pages/UpdateCastlePage"; // Update Castle Page
import ErrorBoundary from "./components/ErrorBoundary"; // Error Boundary Component
import CodexPage from "./pages/CodexPage"; // ✅ Import the Codex Page
import "./App.css";
import Nep2ynPage from "./pages/Nep2ynPage";
import PoetryBookPage from "./pages/PoetryBookPage";



function App() {
  const [walletAddress, setWalletAddress] = useState("");

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        const provider = new BrowserProvider(window.ethereum);
        const accounts = await provider.send("eth_requestAccounts", []);
        setWalletAddress(accounts[0]);
        console.log("Connected Wallet Address:", accounts[0]);
      } catch (err) {
        console.error("Failed to connect wallet:", err);
      }
    } else {
      alert("MetaMask is not detected. Please install it.");
    }
  };

  return (
    <ErrorBoundary>
      <Router>
        {/* Navigation */}
        <nav className="navbar bg-brandBlack border-b border-brandWhite p-4">
  <ul className="nav-links flex justify-around w-full text-brandWhite font-gothic text-lg">
    <li><Link to="/">ЗАМОК</Link></li>
    <li><Link to="/nfts">ВАМПТЕХ</Link></li>

    {/* Temporarily hide feed/world button for deployment */}
    {false && (
      <li><Link to="/gallery">МИР</Link></li>
    )}
  </ul>
</nav>


        {/* Wallet Status */}
        <div className="wallet-status text-center py-4 text-brandWhite">
          {walletAddress ? (
            <p className="wallet-connected">
              Connected Wallet: <span className="font-bold">{walletAddress}</span>
            </p>
          ) : (
            <button
              onClick={connectWallet}
              className="wallet-connect-button px-4 py-2 border border-brandWhite bg-brandBlack text-brandWhite rounded-md hover:bg-brandWhite hover:text-brandBlack transition"
            >
              Connect Wallet
            </button>
          )}
        </div>

        {/* Routes */}
        <Routes>
  <Route path="/" element={<HomePage />} />
  <Route path="/nfts" element={<NFTPage />} />

  {/* Gallery */}
  <Route path="/gallery" element={<GalleryPage />} />           {/* all gallery posts */}
  <Route path="/gallery/:tag" element={<VaultPage />} />        {/* specific user gallery */}

  {/* Records */}
  <Route path="/records" element={<RecordsPage />} />           {/* all records */}
  <Route path="/records/:tag" element={<RecordsPage />} />      {/* specific user records */}

  {/* Sounds / Audio */}
<Route path="/sounds" element={<SoundsPage />} />          {/* all sounds */}
<Route path="/sounds/:tag" element={<SoundsPage />} />     {/* specific user sounds */}

  {/* Signup / Update */}
  <Route path="/signup" element={<SignupPage />} />
  <Route path="/update-castle" element={<UpdateCastlePage />} />

  {/* Crypt */}
  <Route path="/crypt" element={<CryptPage />} />               {/* self view */}
  <Route path="/crypt/:walletAddress" element={<CryptPage />} />{/* public view */}

  {/* Extras */}
  <Route path="/castle/:castleNumber" element={<HomePage />} />
  <Route path="/codex" element={<CodexPage />} />
  <Route path="/nep2yn" element={<Nep2ynPage />} />

  {/* 🔮 Catch-all route for dynamic 3AMOK profiles like /45783AMOK */}
  <Route path="/:castleId" element={<HomePage />} />

  <Route path="/poetry/:bookId" element={<PoetryBookPage />} />
</Routes>


      </Router>
    </ErrorBoundary>
  );
}

export default App;